import { pipe } from "fp";

import React from "react";
import { CSVLink } from "react-csv";

import { Asset } from "~/Asset";
import * as Button from "~/Button";
import * as Driver from "~/Driver";
import * as Log from "~/Log";
import { NotApplicable } from "~/NotApplicable";
import { Time } from "~/Time";

type Download = {
  readonly "Start Date": string;
  readonly "Start Time": string;
  readonly "Stop Date": string;
  readonly "Stop Time": string;
  readonly Asset: string;
  readonly "Possible Driver": string;
  readonly Distance: string;
  readonly "Location Start": string;
  readonly "Location Stop": string;
};

const fromUnassigned = (unassigned: Log.Unassigned.Unassigned): Download => {
  const now = Time.DateTime.now();
  const interval = { stop: now, ...unassigned.interval };
  return {
    "Start Date": Time.DateTime.toDateOnlyMMMDYYYY(interval.start),
    "Start Time": Time.DateTime.toHMMSS(interval.start),
    "Stop Date": Time.DateTime.toDateOnlyMMMDYYYY(interval.stop),
    "Stop Time": Time.DateTime.toHMMSS(interval.stop),
    Asset: Asset.name(unassigned),
    "Possible Driver":
      Driver.Name.toString(unassigned.driver.name) ??
      (unassigned.driver.id
        ? `Driver ${unassigned.driver.id}`
        : NotApplicable.text()),
    Distance: `${unassigned.distance.miles} mi`,
    "Location Start": unassigned.location.start,
    "Location Stop": unassigned.location.stop ?? NotApplicable.text(),
  };
};

export const Component = () =>
  pipe(
    Log.Unassigned.Route.useRouteInterval(),
    Log.Unassigned.useOrEmpty,
    ({ logs }) => logs.map((log) => fromUnassigned(log)),
    ([first, ...rest]) =>
      !first ? (
        <Download.Component disabled />
      ) : (
        <CSVLink
          target="_blank"
          headers={Object.keys(first)}
          data={[first, ...rest]}
          filename={`unassigned-export-${Time.DateTime.toISOWithoutTime(
            Time.DateTime.now()
          )}.csv`}
        >
          <Download.Component />
        </CSVLink>
      )
  );

namespace Download {
  export const Component = (props: { readonly disabled?: boolean }) => (
    <Button.Component
      action
      title="Download"
      icon="$icon_download_line"
      {...props}
    />
  );
}
